import AirportApproval from '../../../Screens/Airports/AirportApprovalPage';
import {
  ADD_AIRPORT_FAILURE,
  ADD_AIRPORT_REQUEST,
  ADD_AIRPORT_SUCCESS,
  DELETE_AIRPORT_FAILURE,
  DELETE_AIRPORT_REQUEST,
  DELETE_AIRPORT_SUCCESS,
  FETCH_AIRPORTS_FAILURE,
  FETCH_AIRPORTS_REQUEST,
  FETCH_AIRPORTS_SUCCESS,
  UPDATE_AIRPORT_REQUEST,
  UPDATE_AIRPORT_SUCCESS,
  UPDATE_AIRPORT_FAILURE,
  FETCH_ALL_AIRPORT_REQUEST,
  FETCH_ALL_AIRPORT_SUCCESS,
  FETCH_ALL_AIRPORT_FAILURE,
  VIEW_AIRPORT_REQUEST,
  VIEW_AIRPORT_SUCCESS,
  VIEW_AIRPORT_FAILURE,
  RESET_AIRPORT_STATE,
  UPDATE_AIRPORT_APPROVAL_STATUS_REQUEST,
  UPDATE_AIRPORT_APPROVAL_STATUS_SUCCESS,
  UPDATE_AIRPORT_APPROVAL_STATUS_FAILURE,
  APPROVE_AIRPORT_UPDATE_REQUEST,
  APPROVE_AIRPORT_UPDATE_SUCCESS,
  APPROVE_AIRPORT_UPDATE_FAILURE,
} from '../types/airportTypes';
const initialState = {
  airportsList: {
    data: [],
    totalRecords: 0,
    deleteLoading: false,
    loading: false,
    error: null,
  },
  airport: {
    loading: false,
    error: null,
    success: null,
  },
  updateAirport: {
    loading: false,
    error: null,
    successMessage: null,
  },
  airportDetails: {
    data: [],
    loading: false,
    error: null,
  },
  airportApproval: {
    loading: false,
    successMessage: null,
    errorMessage: null,
  },
  loading: false,
  success: false,
  error: null,
};
const airportReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AIRPORT_REQUEST:
      return {
        ...state,
        airport: { ...state.airport, loading: true, error: null },
      };
    case ADD_AIRPORT_SUCCESS:
      return {
        ...state,
        airport: {
          ...state.airport,
          loading: false,
          success: action.payload?.message || 'No message',
          error: null,
        },
      };
    case ADD_AIRPORT_FAILURE:
      return {
        ...state,
        airport: {
          ...state.airport,
          loading: false,
          error: action.payload,
          success: null,
        },
      };

    case FETCH_AIRPORTS_REQUEST:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          deleteLoading: false,
          loading: true,
          error: null,
        },
      };
    case FETCH_AIRPORTS_SUCCESS:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          data: action.payload.data || [],
          totalRecords: action.payload.totalRecords || 0,
          loading: false,
          deleteLoading: false,
        },
      };
    case FETCH_AIRPORTS_FAILURE:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          loading: false,
          error: action.payload,
          deleteLoading: false,
        },
      };
    case FETCH_ALL_AIRPORT_REQUEST:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          deleteLoading: false,
          loading: true,
          error: null,
        },
      };
    case FETCH_ALL_AIRPORT_SUCCESS:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          data: action.payload.data || [],
          totalRecords: action.payload.totalRecords || 0,
          loading: false,
          deleteLoading: false,
        },
      };
    case FETCH_ALL_AIRPORT_FAILURE:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          loading: false,
          error: action.payload,
          deleteLoading: false,
        },
      };

    case DELETE_AIRPORT_REQUEST:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          loading: false,
          deleteLoading: true,
        },
      };
    case DELETE_AIRPORT_SUCCESS:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          data: state.airportsList.data.filter(
            (airport) => airport.id !== action.payload
          ),
          totalRecords: state.airportsList.totalRecords - 1,
          loading: false,
          deleteLoading: false,
        },
        airport: {
          ...state.airport,
          loading: false,
          error: null,

          success: action.payload,
        },
      };
    case DELETE_AIRPORT_FAILURE:
      return {
        ...state,
        airportsList: {
          ...state.airportsList,
          loading: false,
          error: action.payload,
          deleteLoading: false,
        },
      };
    case UPDATE_AIRPORT_REQUEST:
      return {
        ...state,
        updateAirport: {
          ...state.updateAirport,
          loading: true,
          error: null,
        },
      };
    case UPDATE_AIRPORT_SUCCESS:
      return {
        ...state,
        updateAirport: {
          ...state.updateAirport,
          loading: false,
          successMessage: action.payload,
        },
      };
    case UPDATE_AIRPORT_FAILURE:
      return {
        ...state,
        updateAirport: {
          ...state.updateAirport,
          loading: false,
          error: action.payload,
        },
      };

    case RESET_AIRPORT_STATE:
     
      return {
        ...state,
        airport: {
          ...state.airport,
          loading: false,
          error: null,
          success: null,
        },
        airportsList: {
          ...state.airportsList,
          data: [],
          deleteLoading: false,
          loading: false,
          error: null,
        },
        airportApproval: {
          ...state.airportApproval,
          loading: false,
          successMessage: null,
          errorMessage: null,
        },
        updateAirport: {
          ...state.updateAirport,
          loading: false,
          error: null,
          successMessage: null,
        },
        airportDetails: {
          ...state.airportDetails,
          data: [],

          loading: false,
          error: null,
        },
      };
    case VIEW_AIRPORT_REQUEST:
      return {
        ...state,
        airportDetails: { loading: true, data: null, error: null },
      };
    case VIEW_AIRPORT_SUCCESS:
      return {
        ...state,
        airportDetails: { loading: false, data: action.payload, error: null },
      };
    case VIEW_AIRPORT_FAILURE:
      return {
        ...state,
        airportDetails: { loading: false, data: null, error: action.payload },
      };

    case UPDATE_AIRPORT_APPROVAL_STATUS_REQUEST:
      return {
        ...state,
        updateAirport: { ...state.updateAirport, loading: true, error: null },
      };
    case UPDATE_AIRPORT_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        updateAirport: {
          ...state.updateAirport,
          loading: false,
          successMessage:
            action.payload?.message || 'Approval status updated successfully',
        },
      };
    case UPDATE_AIRPORT_APPROVAL_STATUS_FAILURE:
      return {
        ...state,
        updateAirport: {
          ...state.updateAirport,
          loading: false,
          error: action.payload,
        },
      };

    case APPROVE_AIRPORT_UPDATE_REQUEST:
      return {
        ...state,
        airportApproval: {
          ...state.airportApproval,
          loading: true,
          successMessage: null,
          errorMessage: null,
        },
      };
    case APPROVE_AIRPORT_UPDATE_SUCCESS:
      return {
        ...state,
        airportApproval: {
          ...state.airportApproval,
          loading: false,
          successMessage: action?.payload?.message,
          errorMessage: null,
        },
      };
    case APPROVE_AIRPORT_UPDATE_FAILURE:
      return {
        ...state,
        airportApproval: {
          ...state.airportApproval,
          loading: false,
          successMessage: null,
          errorMessage: action?.payload?.message,
        },
      };

    default:
      return state;
  }
};
export default airportReducer;
